import { Box, TextField } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import GenericFilterBox from "../common/GenericFilterBox";

const ETollFilterAndSearch = (props: any) => {
  const { t } = useTranslation(["operation"]);
  const resetData = props.resetData;
  const eTollData = props.eTollData;
  const setETollData = props.setETollData;
  const resetForm = props.resetForm;
  const setResetForm = props.setResetForm;
  const setIsFirstTimeRender = props.setIsFirstTimeRender;

  const handleChange = (e: any) => {
    setETollData({ ...eTollData, [e.target.name]: e.target.value });
  };

  const searchEToll = (e: any) => {
    e.preventDefault();
	setIsFirstTimeRender(false);
    setResetForm(!resetForm);
  };

  return (
    <Box>
      <form id="idETollForm" onSubmit={(event) => searchEToll(event)}>
        <GenericFilterBox
          formId="idETollForm"
          onReset={resetData}
          showExtrasFilters={false}
        >
          <Box>
            <TextField
              variant="standard"
              fullWidth
              id="plate"
              name="plate"
              value={eTollData.plate}
              label={t("eToll.plate")}
              onChange={(event) => handleChange(event)}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>

          <Box>
            <TextField
              id="vin"
              name="vin"
              fullWidth
              label={t("eToll.vin")}
              value={eTollData.vin}
              onChange={(event) => handleChange(event)}
              variant="standard"
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>

          <Box>
            <TextField
              id="number"
              name="number"
              fullWidth
              label={t("eToll.number")}
              value={eTollData.number}
              onChange={(event) => handleChange(event)}
              variant="standard"
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>
        </GenericFilterBox>
      </form>
    </Box>
  );
};

export default ETollFilterAndSearch;
